import { useEffect, useState } from "react";
import { api, fmtDateTime } from "@/lib/api";
import { PageHeader, Empty } from "@/components/Bits";

export default function Runs() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/runs").then((r) => setRows(r.data)); }, []);
  return (
    <>
      <PageHeader eyebrow="History" title="Research Runs" />
      {rows.length === 0 ? <Empty testid="runs-empty">No research runs yet.</Empty> : (
        <div className="kh-card overflow-x-auto">
          <table className="w-full text-left text-sm" data-testid="runs-table">
            <thead><tr className="border-b text-[11px] uppercase tracking-wider text-muted-foreground">
              {["When", "Track", "Niche", "Area", "Found", "Dupes", "Suppr.", "Audited", "Qualified", "Time", "By"].map((h) => <th key={h} className="px-4 py-3">{h}</th>)}
            </tr></thead>
            <tbody>{rows.map((r) => (
              <tr key={r.id} className="border-b last:border-0" data-testid={`run-row-${r.id}`}>
                <td className="px-4 py-3 text-muted-foreground">{fmtDateTime(r.created_at)}</td>
                <td className="px-4 py-3">{r.track_name}</td><td className="px-4 py-3">{r.niche_label}</td>
                <td className="px-4 py-3 text-muted-foreground">{[...new Set([r.params.city, r.params.province].filter(Boolean).flatMap((x) => x.split(",").map((s) => s.trim())))].join(", ") || "—"}{r.params.lat ? ` · ${r.params.radius_km}km` : ""}</td>
                {["candidates", "duplicates", "suppressed", "audited"].map((k) => <td key={k} className="px-4 py-3 font-mono">{r[k]}</td>)}
                <td className="px-4 py-3 font-mono text-primary">{r.qualified}</td>
                <td className="px-4 py-3 font-mono text-muted-foreground">{r.duration_s}s</td>
                <td className="px-4 py-3 text-muted-foreground">{r.created_by}{r.notes?.length ? " ⚠" : ""}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}
    </>
  );
}
